import axios from 'axios'
import format from 'date-fns/format'
import modal from '../components/modal'
import { userAccess } from '@/mixins/user-access'
import { displayAlert } from '@/mixins/alert'

export const root = {
  data () {
    return {
      dateFormatDisplay: 'MM/DD/YYYY',
      dateFormat: 'YYYY-MM-DD',
      from: 0,
      queryParts: {
        must: [],
        must_not: []
      },
      search: '',
      searchSize: 25,
      sort: [
        {
          '_score': 'desc'
        }
      ],
      taxOptions: [
        'ALCOHOL',
        'BAKERY',
        'BEAUTY CARE',
        'DAIRY',
        'DELI',
        'FROZEN FOODS',
        'GENERAL MERCHANDISE',
        'GROCERY',
        'HEALTH CARE',
        'IN STORE MEAL',
        'MEAT',
        'PET FOOD AND ACCESSORIES',
        'PHARMACY',
        'PRODUCE',
        'REFRIGERATED SEAFOOD',
        'TOBACCO'
      ],
      totalResults: 0,
      itemHeaders: [
        {
          text: 'Source',
          align: 'start',
          sortable: false,
          value: 'source_name',
          class: 'text-no-wrap accent white--text'
        },
        {
          text: 'Item Id',
          align: 'start',
          sortable: false,
          divider: false,
          value: 'item_id',
          class: 'text-no-wrap accent white--text'
        },
        {
          text: 'Name',
          align: 'start',
          sortable: false,
          value: 'description',
          class: 'text-no-wrap accent white--text'
        },
        {
          text: 'UPC/PLU',
          sortable: false,
          value: 'displaycode',
          class: 'text-no-wrap accent white--text'
        },
        {
          text: 'Vendor Id',
          align: 'start',
          sortable: false,
          value: 'vendor_id',
          class: 'text-no-wrap accent white--text'
        },
        {
          text: 'Vendor Name',
          align: 'start',
          sortable: false,
          value: 'vendor_name',
          class: 'text-no-wrap accent white--text'
        },
        {
          text: 'Department',
          align: 'start',
          sortable: false,
          value: 'department',
          class: 'text-no-wrap accent white--text'
        },
        {
          text: 'Category',
          align: 'start',
          sortable: false,
          value: 'category',
          class: 'text-no-wrap accent white--text'
        },
        {
          text: 'Sub-Category',
          align: 'start',
          sortable: false,
          value: 'subcategory',
          class: 'text-no-wrap accent white--text'
        },
        {
          text: 'Pack Size',
          align: 'start',
          sortable: false,
          value: 'pack_size',
          class: 'text-no-wrap accent white--text'
        },
        {
          text: 'Sale Price',
          align: 'start',
          sortable: false,
          value: 'sale_price',
          class: 'text-no-wrap accent white--text'
        },
        {
          text: 'Cost',
          align: 'end',
          sortable: false,
          value: 'cost',
          class: 'text-no-wrap accent white--text'
        }
      ]
    }
  },
  components: {
    'modal': modal
  },
  mixins: [userAccess, displayAlert],
  computed: {
    disabled () {
      return this.readWrite !== 'write'
    }
  },
  methods: {
    isItemInArray (item, arr) {
      if (arr.length > 0) {
        return arr.some(arrItem => {
          return (arrItem.source === item.source) && (arrItem.item_id === item.item_id)
        })
      }
      return false
    },
    resultMath () {
      let anticipated = parseInt(this.from) + parseInt(this.searchSize)
      if (parseInt(anticipated) > parseInt(this.totalResults)) {
        return this.totalResults
      } else {
        return anticipated
      }
    },
    sortClass (field) {
      let rV = false
      this.sort.forEach(sortField => {
        if (Object.keys(sortField).includes(field)) {
          rV = true
        }
      })
      return rV
    },
    sortDirClass (field) {
      let rV = false
      this.sort.forEach(sortField => {
        if (sortField[field] === 'asc') {
          rV = true
        }
      })
      return rV
    },
    backOne () {
      if (this.from !== 0 && this.from < this.totalResults) {
        this.from = this.from - this.searchSize
      } else {
        this.from = 0
      }
    },
    forwardOne () {
      if ((this.from + this.searchSize) < this.totalResults) {
        this.from = this.from + this.searchSize
      } else {
        let resultsLeft = this.totalResults - (this.from + this.searchSize)
        this.from = resultsLeft
      }
    },
    getUUID () {
      return axios.post('https://6gte2wd0x2.execute-api.us-east-1.amazonaws.com/default/ipro_uuid').then(response => {
        return response.data
      })
    },
    formatDates (date, time) {
      let formattedDates = ''
      if (time === false) {
        if (date) {
          formattedDates = format(date, this.dateFormat)
          return formattedDates
        }
      } else {
        formattedDates = format(date, 'YYYY/MM/DD HH:mm:ss')
        return formattedDates
      }
    },
    formatDatesDisplay (date) {
      let formattedDates = ''
      if (date) {
        formattedDates = format(date, this.dateFormatDisplay)
      }
      return formattedDates
    },
    pad (n, width, z) {
      z = z || '0'
      n = n + ''
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n
    }
  }
}

// import format from 'date-fns/format'

// export const foundation = {
//   data () {
//     return {
//       dateFormatDisplay: 'MM/DD/YYYY',
//       dateFormat: 'YYYY-MM-DD'
//     }
//   },
//   methods: {
//     formatDates (date, time) {
//       let formattedDates = ''
//       if (time === false) {
//         if (date) {
//           formattedDates = format(date, this.dateFormat)
//           return formattedDates
//         }
//       } else {
//         formattedDates = format(date, 'YYYY/MM/DD HH:mm:ss')
//         return formattedDates
//       }
//     },
//     formatDatesDisplay (date, dateTwo) {
//       let formattedDates = ''
//       if (date) {
//         formattedDates = format(date, this.dateFormatDisplay)
//       }
//       if (dateTwo) {
//         formattedDates += ' - ' + format(dateTwo, this.dateFormatDisplay)
//       }
//       return formattedDates
//     }
//   }
// }



// WEBPACK FOOTER //
// ./src/mixins/root.js